/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Divider,
  HStack,
  Heading,
  Spinner,
  Stack,
  Text,
  Collapse,
  IconButton,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { SearchContext } from '../context';
import { SearchCompanyPagesListing } from './listing';
import { SearchCompanyPagesFilters } from './filters';
import { isMobile } from 'react-device-detect';
import { useDisclosure } from '@mybridge/ui';
import { Filters } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const SearchCompanyPages = forwardRef(
  ({ count, listing, ...props }, ref) => {
    const {
      companyPagesFetchNextPage,
      companyPagesHasNextPage,
      companyPagesSearchIsFetching,
      companyPagesTotalCount,
      query,
    } = useContext(SearchContext);
    const { t } = useTranslator();
    const filterDisc = useDisclosure();
    return (
      <Stack>
        {isMobile ? (
          <Collapse style={{overflow:"inherit"}}  in={filterDisc?.isOpen} animateOpacity>
            <SearchCompanyPagesFilters />
            <Divider my={2} />
          </Collapse>
        ) : (
          ''
        )}
        <Stack spacing={0}>
          <HStack  justifyContent="space-between">
            <Heading as="h1" pl={2} fontSize="20px" color="brandPrimary.500" fontWeight="400">{t('profileNetwork.pages') || "Pages"}</Heading>
            {companyPagesSearchIsFetching ? <Spinner /> : ''}
            {isMobile && (
            <IconButton
              icon={<Filters />}
              onClick={() => filterDisc.onToggle()}
              variant="transparent"
            />
          )}
          </HStack>
          {query?.query?.length && companyPagesTotalCount ? (
            <Text size="sm">{companyPagesTotalCount} {t('pageJobs.results') || "results"}</Text>
          ) : (
            ''
          )}
        </Stack>
        <SearchCompanyPagesListing />
        {/* {companyPagesHasNextPage ? (
          <HStack justifyContent="center">
            <Button
              isLoading={companyPagesSearchIsFetching}
              onClick={companyPagesFetchNextPage}
              variant="secondary"
            >
              Load More
            </Button>
          </HStack>
        ) : (
          ''
        )} */}
      </Stack>
    );
  }
);
